import { Box } from '@dtx-company/design-system/src'
import { ErrorPage } from '../ErrorPage'
import { FC } from 'react'

export const PageErrorFallback: FC = () => (
  <Box sx={{ height: '100%' }}>
    <ErrorPage />
  </Box>
)

export const FullPageErrorFallback: FC = () => (
  <Box sx={{ height: '100vh' }}>
    <ErrorPage />
  </Box>
)
